import { useState, useEffect, useRef } from 'react'
import Box from '@mui/joy/Box'
import { AssetEditor } from '../components/AssetEditor.js'
import { useNavigate } from 'react-router-dom'
import { canvasActions } from '../common/canvasActions'
import { Loading } from '../components/ui/Loading'
import { CampaignAPI } from '../api/CampaignAPI'
import { useParams } from 'react-router-dom'

export const CampaignAssetEditor = () => {
    const [canvas, setCanvas] = useState(null)
    const [error, setError] = useState(null)
    const [isLoading, setIsLoading] = useState(false)
    const { campaignId, assetId } = useParams()
    const navigate = useNavigate()

    useEffect(() => {
        // TODO: ADD ERROR HANDLING!
        CampaignAPI.getAsset(campaignId, assetId)
            .then((response) => {
                console.log(response)
                setCanvas(response.data.canvas)
            })
            .catch((e) => {
                console.log(e)
            })
    }, [])

    const handleSave = (canvas) => {
        setIsLoading(true)
        let screenshot = canvasActions.takeScreenshot(canvas)
        CampaignAPI.updateAssetV2(
            campaignId,
            assetId,
            screenshot,
            canvas.toJSON()
        )
            .then((response) => {
                console.log(response)
                window.location.reload()
            })
            .catch((e) => {
                console.log(e)
                setIsLoading(false)
                setError(JSON.stringify(e))
            })
    }

    if (isLoading) {
        return <Loading message="submitting..." />
    }

    return (
        <AssetEditor
            canvasJSON={canvas}
            onSave={handleSave}
            onExit={() => navigate(`/merchant/view_campaign_v2/${campaignId}`)}
            errorMsg={error}
        />
    )
}
